import { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@/components/@IntranetLibrary/Button/TextButton';
import RefreshIcon from '@/public/icons/approval/refresh.svg';

type ResetTextButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
>;

/** 결재라인/참조인 공용 '초기화' 텍스트 버튼 */
const ResetTextButton = (props: ResetTextButtonProps) => {
  const { t } = useTranslation();
  return (
    <TextButton
      variant="keyColor"
      size="medium"
      underline
      startIcon={<RefreshIcon width={12} height={12} />}
      {...props}
    >
      {t('초기화')}
    </TextButton>
  );
};

export default ResetTextButton;
